import styled from "@emotion/styled";

const DIALOG_Z = 3000;
const BACKDROP_Z = 2999;
const CONTENT_Z = 3001;

export const ModalDialog = styled.dialog<{ isOpen: boolean }>`
  border: none;
  color: #FAFAFA;
  background: transparent;
  outline: none;
  font-size: 14px;
  line-height: 194%;
  letter-spacing: 0.17px;
  position: fixed;
  inset: 0;
  z-index: ${DIALOG_Z};

  /* Centrado + scroll a nivel viewport */
  display: ${(p) => (p.isOpen ? "flex" : "none")};
  align-items: center;
  justify-content: center;
  padding: 24px;
  overflow: visible;
  overscroll-behavior: contain; /* evita scroll del fondo */

  @media (max-width: 767px) {
    width: 100vw;
    height: 100vh;
    height: 100dvh;
    max-width: none;
    max-height: none;
    margin: 0;
    padding: 12px;
    box-sizing: border-box;
    align-items: flex-start;
    overflow-x: hidden;
    overflow-y: auto;
  }

  ${(props) =>
    props.isOpen &&
    `
    &.open { display: flex; }
  `}
`;

export const ModalBackdrop = styled.div<{ z?: number }>`
  position: fixed;
  inset: 0;
  backdrop-filter: blur(3px);
  background: rgba(0, 0, 0, 0.25);
  z-index: ${(props) => props.z ?? BACKDROP_Z};
`;

export const ModalContentWrapper = styled.div<{ allowOverflow?: boolean }>`
  position: relative;
  z-index: ${CONTENT_Z};
  isolation: isolate;
  width: 100%;
  max-width: min(960px, 96vw);
  max-height: 90vh;
  background: #0D3547;
  border-radius: 16px;
  overflow: visible;
  scrollbar-width: none;

  @media (max-width: 767px) {
    width: max-content;
    max-width: 100%;
    max-height: none;
    margin: auto 0;
    border-radius: 12px;
  }
`;

